import { connect } from 'react-redux';
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import { createSelector } from 'reselect';
import { tryDeleteWish } from 'store/deleteWish/actions';
import { editWish } from 'store/editWish/actions';
import { getIsAdmin, getWish, getUserId, getWhoWillBuy } from 'store/firebase/selectors';
import { getLanguage } from 'store/language/selectors';
import Wish from './Wish';

const mapStateToProps = createSelector(
  getIsAdmin,
  getWish,
  getUserId,
  getWhoWillBuy,
  getLanguage,
  (isAdmin, wish, userId, whoWillBuy, language) => ({
    isAdmin, wish, userId, whoWillBuy, language
  })
);

const actions = (dispatch, { wishId, firebase }) => ({
  onDelete: () => {
    dispatch(tryDeleteWish(wishId));
  },
  onEdit: () => {
    dispatch(editWish(wishId));
  }
});

export default compose(
  firebaseConnect(props => ([
    `wishes/${props.wishId}`,
    'admins',
    `willBuys/${props.wishId}`
  ])),
  connect(mapStateToProps, actions)
)(Wish);



// WEBPACK FOOTER //
// ./src/components/Wish/index.js